import PinInput from "react-pin-input";
import { useState } from "react";
import { Alert, Button } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LOGIN_TYPE_EMAIL, LOGIN_TYPE_GA } from "constants/login.constants";
import {
  useSendCodeTwoFaMutation,
  useVerifyTwoFaCodeMutation,
} from "services/authServiceWithToken";
import useNotification from "shared/hooks/useNotification";
import { useDispatch } from "react-redux";
import { updateAuth } from "modules/auth/authSlice";
import Support from "shared/components/Support";
import { useAuth } from "shared/hooks";
import { NavigateProfileTab } from "constants/common.constants";
import { useCreateAuditMutation } from "services/auditService";

interface SetupVerifyProps {
  onBack: () => void;
}

function SetupVerify(props: SetupVerifyProps) {
  const { onBack } = props;
  const [otp, setOtp] = useState<string>("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [errors, setErrors] = useState({
    show: false,
    message: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { contextHolder, openNotificationWithIcon } = useNotification();
  const { isVerify2faEmail, isVerify2faGa, isVerifyPassword } = useAuth();

  //API
  const [verifyCode, { isLoading }] = useVerifyTwoFaCodeMutation();
  const [sendCodeTwoFa] = useSendCodeTwoFaMutation();
  const [createAudit] = useCreateAuditMutation();

  const handleSubmitForm = () => {
    verifyCode({ verify_code: otp, mode: Number(searchParams.get("type")) })
      .unwrap()
      .then((res) => {
        dispatch(
          updateAuth({
            isVerify2faEmail:
              Number(searchParams.get("type")) === LOGIN_TYPE_EMAIL ? true : isVerify2faEmail,
            isVerify2faGa:
              Number(searchParams.get("type")) === LOGIN_TYPE_GA ? true : isVerify2faGa,
            isVerifyPassword: isVerifyPassword,
          })
        );
        createAudit({
          new_value: "",
          old_value: "",
          page_name: "Profile",
          type: `Setup ${
            Number(searchParams.get("type")) === LOGIN_TYPE_EMAIL ? "Email" : "Google Authenticator"
          }`,
        });
        navigate(`/admin/profile?type=${NavigateProfileTab.TWO_FA_KEY_TAB}`);
      })
      .catch((err) => {
        setErrors({ show: true, message: err?.data?.message });
      });
  };

  const handleResendCode = async () => {
    const res = await sendCodeTwoFa({ mode: Number(searchParams.get("type")) }).unwrap();
    if (res) {
      openNotificationWithIcon({
        type: "success",
        description: "Resend code successful.",
      });
    }
  };

  const handleBack = () => {
    if (Number(searchParams.get("type")) === LOGIN_TYPE_EMAIL) {
      navigate(`/admin/profile?type=${NavigateProfileTab.TWO_FA_KEY_TAB}`);
    }
    if (Number(searchParams.get("type")) === LOGIN_TYPE_GA) {
      onBack();
    }
  };

  return (
    <div className="setup">
      <h3 className="setup__title">
        {Number(searchParams.get("type")) === LOGIN_TYPE_EMAIL
          ? "Enable Two-Factor Authentication (2FA)"
          : "Verify Authenticator App"}
      </h3>
      {Number(searchParams.get("type")) === LOGIN_TYPE_EMAIL && (
        <p className="setup__des">
          Enter the verification code that has been sent to your email.
          <br /> Don’t see the email?{" "}
          <span onClick={handleResendCode} className="forgotPassword__form-text-try">
            Resend code
          </span>
          .
          <Support />
        </p>
      )}
      {Number(searchParams.get("type")) === LOGIN_TYPE_GA && (
        <p className="setup__des">
          Enter the code you see from Google Authenticator to make sure it works.
        </p>
      )}
      <div className="login__verify">
        <PinInput
          length={6}
          initialValue=""
          type="numeric"
          onChange={(value: any) => {
            setErrors({ ...errors, show: false });
          }}
          inputMode="number"
          placeholder={"___"}
          style={{ padding: "10px 7px" }}
          onComplete={(value: any, index: number) => {
            setOtp(value);
          }}
          autoSelect={true}
          regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
        />
      </div>
      <Button
        loading={isLoading}
        disabled={!otp}
        onClick={handleSubmitForm}
        className="login__password-btn"
      >
        Verify
      </Button>
      <div>
        <button onClick={handleBack} className="login__process-2fa-back">
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.3327 10H4.66602"
              stroke="#5C1DE9"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.4993 15.8337L4.66602 10.0003L10.4993 4.16699"
              stroke="#5C1DE9"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span className="login__process-2fa-back-text">Back</span>
        </button>
      </div>
      {errors?.show && (
        <Alert style={{ marginTop: "0.7rem" }} message={errors?.message} type="error" />
      )}

      {contextHolder}
    </div>
  );
}

export default SetupVerify;
